import { LandingPageBase } from '../landing-page-base/landing-page-base.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-guid-base',
    templateUrl: './guid-base.component.html',
    styleUrls: ['./guid-base.component.css'],
    standalone: true,
    imports: [MatCardModule, MatButtonModule, LandingPageBase, MatProgressSpinnerModule]
})

export class GuidBase implements OnInit {
    headerText: string = 'Oops!';
    contentText: string = 'Please access your account using the appropriate link provided by Minster. If you believe this is an error, please contact support.';
    isLoading: boolean = true;

    constructor() {
    }

    ngOnInit(): void {
         setTimeout(() => {
            this.isLoading = false;
        }, 3000);
        
    }
}